import React from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Space,
  message,
  Modal,
  Form,
  Select,
  Image,
  Tooltip,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import Autocomplete from "react-google-autocomplete";
import DisplayLocationMap from "./DisplayLocationMap";
import { CloseOutlined } from "@ant-design/icons";
import ListTable from "./ListTable";
import config from "../config";
import withRouter from "../withRouter";
import StationStore from "../store/StationStore";
import { Link } from "react-router-dom";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import CountryStore from "../store/CountryStore";
const { Option } = Select;

class StationList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.stationStore = new StationStore(this);
    this.countryStore = new CountryStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      loadList: 0,
      showStationReg: false,
      update: 0,
      stationCode: "",
      addressMap: false,
      addressInfo: [],
    };
    this.columns = [
      {
        title: context.translate("_STATION_CODE_"),
        dataIndex: "stationCode",
        width: 15,
        ellipsis: true,
      },
      {
        title: context.translate("_ARABIC_NAME_"),
        dataIndex: "arabicName",
        width: 15,
        ellipsis: true,
      },
      {
        title: context.translate("_ENGLISH_NAME_"),
        dataIndex: "englishName",
        width: 15,
        ellipsis: true,
      },

      {
        title: context.translate("_FLEET_DASHBORD_VEHICLE_INFORMATION_LONGI_"),
        dataIndex: "longitude",
        width: 15,
        ellipsis: true,
      },
      {
        title: context.translate("_FLEET_DASHBORD_SETTING_LATITUDE_"),
        dataIndex: "latitude",
        width: 15,
        ellipsis: true,
      },
      {
        title: context.translate("_CITY_CODE_"),
        dataIndex: "cityCode",
        width: 15,
        ellipsis: true,
      },
      {
        title: context.translate("_STATIONS_TATUS_"),
        dataIndex: "stationStatus",
        width: 15,
        ellipsis: true,
      },
      {
        title: context.translate("_EMAIL_"),
        dataIndex: "email",
        width: 15,
        ellipsis: true,
      },
      {
        title: context.translate("_FLEET_DASHBORD_NEWPOI_PHONE_"),
        dataIndex: "phone",
        width: 15,
        ellipsis: true,
      },
      {
        title: context.translate("_PHONE_EXTENSION_"),
        dataIndex: "phoneExtension",
        width: 15,
        ellipsis: true,
      },
      {
        title: context.translate("_MANAGER_PHONE_"),
        dataIndex: "managerPhone",
        width: 15,
        ellipsis: true,
      },
      {
        title: context.translate("_REPLY_"),
        dataIndex: "reply",
        width: 15,
        ellipsis: true,
      },
    ];
    this.formRef = React.createRef();
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      Number(this.props.getUserData().isadmin) === 0 ||
      Number(this.props.getUserData().isadmin) === 1
    ) {
      this.props.navigate("/login");
    }
    if (
      this.state.addressMap &&
      prevState.addressMap !== this.state.addressMap
    ) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 10);
    }
  }
  async componentDidMount() {
    await this.stationStore.loadData({ limit: 50, offset: 0 });
    await this.stationStore.getCityCode();
    await this.countryStore.getCountry();

    await this.setState({ pageSize: 50 });

    this.setState({ update: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({ companyId: comp.value, loadList: 1 });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.stationStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 0 });
  }
  onStationRefFinish = async (values) => {
    const response = await this.stationStore.addRegistration(values);

    if (response?.success === "S") {
      message.success(response.data.message);
    } else {
      await message.error(response.data.message);
    }

    if (response.data.message) {
      this.setState({ showStationReg: false });
      this.formRef.current?.resetFields();
    }
  };
  validateNumber = (value, field1) => {
    const value1 = value.replace(/[^0-9+]*/g, "");

    if (value1.length > 0) {
      this.formRef.current.setFieldsValue({ [field1]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field1]: "" });
    }
  };

  validatePhoneNumber = (value, field) => {
    const value1 = value.replace(/[^0-9+]*/g, "");

    if (value1.length > 0) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  searchStation = async (e) => {
    const stationCode = e.target.value;
    this.setState({ stationCode: stationCode });
    if (stationCode.length > 2 || stationCode.length === 0) {
      await this.stationStore.loadData({
        limit: 50,
        offset: 0,
        stationCode: stationCode,
      });
      await this.setState({ update: 1 });
    }
  };
  render() {
    return (
      <>
        {/* <div>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_STATION_LIST_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space style={{}}>
                <Link to={"/companylist"}>
                  <Button type="primary">
                    {this.context.translate("_BACK_")}
                  </Button>
                </Link>
                <Button
                  type="primary"
                  onClick={() => this.setState({ showStationReg: true })}
                >
                  + {this.context.translate("_REGISTER_")}
                </Button>

                <Button
                  style={{ backgroundColor: config.activeColor }}
                  disabled={
                    this.stationStore.StationListArray.length > 0 ? false : true
                  }
                  onClick={async (val) => {
                    const result = [];
                    this.columns.map((obj) => result.push(obj.dataIndex));
                    var getData = {
                      stationCode: this.state.stationCode,
                      colList: result,
                    };
                    await this.stationStore.exportExcel(getData);
                    await this.setState({ loadList: 1 });
                  }}
                >
                  <DownloadOutlined />
                  {this.context.translate("_EXPORT_")}
                </Button>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <Input
                  placeholder={this.context.translate("_STATION_CODE_")}
                  // value={this.state.stationCode}
                  onChange={(e) => this.searchStation(e)}
                />
                {/* <Button
                  type="primary"
                  onClick={async () => {
                    await this.stationStore.loadData({
                      limit: 50,
                      offset: 0,
                      stationCode: this.state.stationCode,
                    });
                    await this.setState({ update: 1 });
                  }}
                >
                  <SearchOutlined />
                </Button> */}
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Space>
                <Link to={"/companylist"}>
                  <Button className="addButtonClass">
                    {this.context.translate("_BACK_")}
                  </Button>
                </Link>
                <Button
                  className="addButtonClass"
                  onClick={() => this.setState({ showStationReg: true })}
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  />
                  {this.context.translate("_REGISTER_")}
                </Button>

                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.stationStore.StationListArray.length > 0 ? false : true
                  }
                  onClick={async () => {
                    const result = [];
                    this.columns.map((obj) => result.push(obj.dataIndex));
                    var getData = {
                      stationCode: this.state.stationCode,
                      colList: result,
                    };
                    await this.stationStore.exportExcel(getData);
                    await this.setState({ loadList: 1 });
                  }}
                >
                  <Tooltip title="Download Excel" placement="bottom">
                    <Image
                      style={{
                        height: 18,
                        width: "auto",
                      }}
                      src={downloadIcon}
                    />
                  </Tooltip>
                </Button>
              </Space>
            </Col>
          </Row>

          <ListTable
            current={this.state.currentPage}
            total={this.stationStore?.total}
            columns={this.columns}
            dataSource={this.stationStore?.StationListArray}
            loading={this.stationStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {/* <Modal
          bodyStyle={{ height: "645px" }}
          className="formShowModal"
          title={this.context.translate("_STATION_REGISTRATION_")}
          open={this.state.showStationReg}
          onCancel={() => this.setState({ showStationReg: false })}
          footer={null}
          width={665}
          centered
          // onOk={}
        > */}

        <Drawer
          className="accountFormDrawer"
          width={716}
          closeIcon={false}
          open={this.state.showStationReg}
          placement={
            this.context.locale.language === "english" ? "right" : "left"
          }
          title={
            <div className="formTitle">
              {this.context.translate("_STATION_REGISTRATION_")}
              <p className="formDescription">
                {this.context.translate("_DRIVER_ADD_DESC_")}
              </p>
            </div>
          }
          footer={false}
          maskClosable={false}
          onOk={() => this.setState({ showStationReg: false })}
          onCancel={() =>
            this.setState({
              showStationReg: false,
            })
          }
        >
          <Form
            ref={this.formRef}
            layout="vertical"
            name="companyFrm"
            onFinish={this.onStationRefFinish}
            initialValues={{ mapSetting: false, mapSetting2: false }}
            style={{ maxWidth: "100%", padding: 0, height: "92%" }}
            className="formClass"
          >
            <Row className="overflowFormInputs">
              <Col span={12} className="waslFormClass">
                <Form.Item
                  className="formFieldsStyle"
                  name="stationCode"
                  label={
                    <span>
                      {this.context.translate("_STATION_CODE_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_STATION_CODE_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Input
                    onChange={(e) =>
                      this.validateNumber(e.target.value, "stationCode")
                    }
                  />
                </Form.Item>

                <Form.Item
                  className="formFieldsStyle"
                  name="arabicName"
                  label={
                    <span>
                      {this.context.translate("_ARABIC_NAME_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_ARABIC_NAME_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  className="formFieldsStyle"
                  name="englishName"
                  label={
                    <span>
                      {this.context.translate("_ENGLISH_NAME_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_ENGLISH_NAME_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  className="formFieldsStyle"
                  name="markLocation"
                  label={this.context.translate("_MARK_LOCATION_")}
                >
                  <Autocomplete
                    style={{
                      width: "100%",
                      height: "40px",
                      boxShadow: "none",
                      padding: "4px 11px",
                      borderWidth: 1,
                      borderStyle: "solid",
                      borderColor: "#d9d9d9",
                      borderRadius: "6px",
                    }}
                    apiKey={config.googleMapKey}
                    onPlaceSelected={async (place) => {
                      await this.setState({ addressMap: true });
                      await this.setState({
                        addressInfo: [
                          place.geometry.location.lat(),
                          place.geometry.location.lng(),
                        ],
                      });
                      this.formRef.current.setFieldsValue({
                        markLocation: place.formatted_address,
                        latitude: place.geometry.location.lat(),
                        longitude: place.geometry.location.lng(),
                      });
                    }}
                    placeholder={this.context.translate(
                      "_PLEASE_ENTER_LOCATION_"
                    )}
                  />
                </Form.Item>

                <Form.Item
                  className="formFieldsStyle"
                  name="latitude"
                  label={
                    <span>
                      {this.context.translate(
                        "_FLEET_DASHBORD_SETTING_LATITUDE_"
                      )}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_FLEET_DASHBORD_SETTING_LATITUDE_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  className="formFieldsStyle"
                  name="longitude"
                  label={
                    <span>
                      {this.context.translate(
                        "_FLEET_DASHBORD_SETTING_LONGITUDE_"
                      )}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_FLEET_DASHBORD_SETTING_LATITUDE_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12} className="waslFormClass">
                <Form.Item
                  className="formFieldsStyle"
                  name="cityCode"
                  label={
                    <span>
                      {this.context.translate("_CITY_CODE_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_CITY_CODE_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Select placeholder={this.context.translate("_SELECT_TYPE_")}>
                    {this.stationStore?.cityCodeArray?.map((val) => {
                      return (
                        <Select.Option value={val.id}>{val.name}</Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>

                <Form.Item
                  className="formFieldsStyle"
                  name="status"
                  initialValue={"1"}
                  label={
                    <span>
                      {this.context.translate("_STATUS_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_STATUS_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Select>
                    <Select.Option value="1">
                      {this.context.translate("_ACTIVE_")}
                    </Select.Option>
                    <Select.Option value="0">
                      {this.context.translate(
                        "_FLEET_USER_USERLIST_STATUS_INACTIVE_"
                      )}
                    </Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  className="formFieldsStyle"
                  name="emailAddress"
                  label={
                    <span>
                      {this.context.translate("_EMAIL_ID_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_EMAIL_ID_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                      type: "email",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  className="formFieldsStyle"
                  label={
                    <span>
                      {this.context.translate("_MOBILE_NUMBER_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_MOBILE_NUMBER_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Space.Compact style={{ width: "100%" }}>
                    <Form.Item
                      name="countryCode"
                      noStyle
                      initialValue={config.countryCode}
                    >
                      <Select style={{ width: "55%", borderRadius: "5px" }}>
                        {this.countryStore?.country?.map((country) => {
                          return (
                            <Option value={parseInt(country.countryId)}>
                              {country.countryCode}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="mobileNumber"
                      noStyle
                      rules={[
                        {
                          required: true,
                          pattern: /^\d{8,10}$/,
                          message: this.context.translate(
                            "_Enter_7_or_10_Digit_Number_"
                          ),
                        },
                      ]}
                      required={false}
                    >
                      <Input
                        style={{ width: "100%" }}
                        onChange={(e) =>
                          this.validatePhoneNumber(
                            e.target.value,
                            "mobileNumber"
                          )
                        }
                      />
                    </Form.Item>
                  </Space.Compact>
                </Form.Item>

                <Form.Item
                  className="formFieldsStyle"
                  name="extensionNo"
                  label={this.context.translate("_EXTENSION_NUMBER_")}
                >
                  <Input
                    onChange={(e) =>
                      this.validateNumber(e.target.value, "extensionNo")
                    }
                  />
                </Form.Item>

                <Form.Item
                  className="formFieldsStyle"
                  label={
                    <span>
                      {this.context.translate("_MOBILE_NUMBER_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_MOBILE_NUMBER_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Space.Compact style={{ width: "100%" }}>
                    <Form.Item
                      name="managerPhoneCountryCode"
                      noStyle
                      initialValue={config.countryCode}
                    >
                      <Select style={{ width: "55%", borderRadius: "5px" }}>
                        {this.countryStore?.country?.map((country) => {
                          return (
                            <Option value={parseInt(country.countryId)}>
                              {country.countryCode}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="managerPhone"
                      noStyle
                      rules={[
                        {
                          required: true,
                          pattern: /^\d{8,10}$/,
                          message: this.context.translate(
                            "_Enter_7_or_10_Digit_Number_"
                          ),
                        },
                      ]}
                      required={false}
                    >
                      <Input
                        style={{ width: "100%" }}
                        onChange={(e) =>
                          this.validatePhoneNumber(
                            e.target.value,
                            "managerPhone"
                          )
                        }
                      />
                    </Form.Item>
                  </Space.Compact>
                </Form.Item>
              </Col>
            </Row>

            <div className="formFooter">
              <Button
                className="formsCancelButton"
                onClick={() => {
                  this.setState({ showStationReg: false });
                }}
              >
                {this.context.translate("_FLEET_DASHBORD_ROUTEADD_CANCELBTN_")}
              </Button>
              <Button htmlType="submit" className="formsSaveButton">
                {this.context.translate("_REGISTER_")}
              </Button>
            </div>
          </Form>
        </Drawer>

        <Modal
          className="multiTracking-popup"
          style={{ padding: "0px !important" }}
          title={
            <div>
              Location On Map
              <CloseOutlined
                onClick={() => this.setState({ addressMap: false })}
              />
            </div>
          }
          maskClosable={false}
          centered
          bodyStyle={{ height: "60vh", padding: "0px" }} // Adjust the dimensions as needed
          width={1000}
          visible={this.state.addressMap}
          onCancel={() => this.setState({ addressMap: false })}
          footer={null}
        >
          <DisplayLocationMap
            addressInfo={
              this.state.addressInfo?.length > 0 && this.state.addressInfo
            }
            formRef={this.formRef}
            address={(address) =>
              this.formRef.current.setFieldsValue({ markLocation: address })
            }
          />
        </Modal>
      </>
    );
  }
}
StationList.contextType = StoreContext;
export default observer(withRouter(StationList));
